import React from 'react';
import { Box, Button } from '@indeed/ifl-components';
import { IndeedLogoKatakana } from '@indeed/ifl-components';
import { Chat, Notification, Hamburger } from '@indeed/ifl-icons';

interface LightApplyHeaderProps {
    onChatClick?: () => void;
    onNotificationClick?: () => void;
    onMenuClick?: () => void;
}

const LightApplyHeader: React.FunctionComponent<LightApplyHeaderProps> = ({
    onChatClick,
    onNotificationClick,
    onMenuClick,
}) => {
    const handleChatClick = () => {
        onChatClick?.();
    };

    const handleNotificationClick = () => {
        onNotificationClick?.();
    };

    const handleMenuClick = () => {
        onMenuClick?.();
    };

    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                backgroundColor: '#FFFFFF',
                padding: '0px 0px 0px 16px',
                inlineSize: '100%',
                blockSize: 'auto',
                minBlockSize: '64px',
            }}
        >
            {/* Logo Section */}
            <Box
                sx={{
                    inlineSize: '82.5px',
                    blockSize: '22px',
                }}
            >
                <IndeedLogoKatakana width="82.5px" height="22px" color="#003A9B" />
            </Box>

            {/* Right Side Navigation Buttons */}
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'flex-end',
                    alignItems: 'center',
                    gap: '2px',
                    padding: '0px 2px',
                }}
            >
                {/* Chat Button */}
                <Box
                    sx={{
                        inlineSize: '52px',
                    }}
                >
                    <Button
                        variant="tertiary"
                        size="lg"
                        onClick={handleChatClick}
                        sx={{
                            padding: '14px',
                            borderRadius: 'sm',
                            minInlineSize: 'auto',
                            inlineSize: 'auto',
                            blockSize: 'auto',
                        }}
                        aria-label="Chat"
                    >
                        <Chat
                            sx={{
                                inlineSize: '24px',
                                blockSize: '24px',
                                color: '#2D2D2D',
                            }}
                        />
                    </Button>
                </Box>

                {/* Notification Button */}
                <Box
                    sx={{
                        inlineSize: '52px',
                    }}
                >
                    <Button
                        variant="tertiary"
                        size="lg"
                        onClick={handleNotificationClick}
                        sx={{
                            padding: '14px',
                            borderRadius: 'sm',
                            minInlineSize: 'auto',
                            inlineSize: 'auto',
                            blockSize: 'auto',
                        }}
                        aria-label="Notifications"
                    >
                        <Notification
                            sx={{
                                inlineSize: '24px',
                                blockSize: '24px',
                                color: '#2D2D2D',
                            }}
                        />
                    </Button>
                </Box>

                {/* Hamburger Menu Button */}
                <Box
                    sx={{
                        inlineSize: '52px',
                    }}
                >
                    <Button
                        variant="tertiary"
                        size="lg"
                        onClick={handleMenuClick}
                        sx={{
                            padding: '14px',
                            borderRadius: 'sm',
                            minInlineSize: 'auto',
                            inlineSize: 'auto',
                            blockSize: 'auto',
                        }}
                        aria-label="Menu"
                    >
                        <Hamburger
                            sx={{
                                inlineSize: '24px',
                                blockSize: '24px',
                                color: '#2D2D2D',
                            }}
                        />
                    </Button>
                </Box>
            </Box>
        </Box>
    );
};

export default LightApplyHeader;
